var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"14","viewBox":"0 0 9 14"}},[_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#222326","stroke-width":"2.5","d":"M8 13L2 6.911 8 1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }